<template>
  <div class="content-card">
    <!--
      @slot content of the card
    -->
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ContentCard'
}
</script>

<style lang="scss" scoped>
.content-card {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}
</style>
